/**
 * True when an event starts inside the editor dock.
 *
 * The canvas and the workspace read shortcut keys on `window`, so a key pressed in
 * a docked form reaches them too: an arrow on a focused select pans the drawing,
 * and Backspace on a focused button deletes the selected marks. Those listeners
 * call this to leave the dock's keys to the form.
 */
export function isEventInsideEditorDock(event: Event): boolean {
  return event.target instanceof Element && event.target.closest('[data-editor-dock]') !== null;
}
